import React, { useState, useRef } from "react";
import { usePapaParse } from "react-papaparse";
import { useCSVDownloader } from "react-papaparse";
import s from "./CsvDownloader.module.scss";
import { swrFetcher } from "../../../../../../libs/api/Endpoints";
import { Button, message } from "antd";
import {
  Message,
  PaginatedSentMessage,
} from "../../../../../../libs/Utils/Types/Message";
import dayjs from "dayjs";

type PropType = {
  filename: string;
  token: string;
  filter: string;
  endpointKey: string;
  pageItems: number;
};

function CsvDownloader({
  filename,
  filter,
  endpointKey,
  token,
  pageItems,
}: PropType) {
  const [loading, setLoading] = useState<boolean>(false);
  const [csvData, setCsvData] = useState<any[]>([]);
  const { jsonToCSV } = usePapaParse();
  const { CSVDownloader, Type } = useCSVDownloader();

  // ref for the CSV downloader
  const csvRef = useRef<HTMLButtonElement>(null);

  const fetchAllMessages = async () => {
    let page = 1;
    const limit = pageItems;
    let allDocs: Message[] = [];
    let totalPages = 1;

    setLoading(true);

    try {
      do {
        const res: PaginatedSentMessage = await swrFetcher([
          endpointKey,
          token,
          { page, limit, ...(filter && { status: filter }) },
        ]);

        allDocs = allDocs.concat(res.data);
        totalPages = res.pagination.totalPages;
        page++;
      } while (page <= totalPages);

      const filteredDocs =
        allDocs &&
        allDocs.map((item) => ({
          messageTitle: item.title,
          mesageType: item.type.replace("_", " ") || "N/A",
          sender: item.user
            ? (item.user?.firstName || "") + " " + item.user?.lastName || "N/A"
            : "N/A",
          contacts: item.totalRecipients || 0,
          creditUsed: item.totalCreditsUsed
            ? item.totalCreditsUsed.toLocaleString()
            : 0,
          date: dayjs.utc(item.sentAt).local().format("MMM D, YYYY"),
          status: item.status || "N/A",
          openRate: item.deliveryRate ? item.deliveryRate.toLocaleString() : 0,
        }));
      setCsvData(filteredDocs);
      message.success("All data fetched — download starting…");

      // trigger the CSV download automatically
      setTimeout(() => {
        csvRef.current?.click();
      }, 500); // slight delay so state updates fully before download
    } catch (error) {
      console.error(`Error fetching ${filename}:`, error);
      message.error(`Failed to fetch ${filename}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.wrapper}>
      <Button onClick={fetchAllMessages} loading={loading} className={s.button}>
        {"Download CSV"}
      </Button>

      {/* Hidden CSV Downloader */}
      {csvData.length > 0 && (
        <CSVDownloader
          type={Type.Button}
          filename={new Date() + " Cloudivi " + filename}
          bom={true}
          config={{ delimiter: ";" }}
          data={() => jsonToCSV(csvData)}
        >
          <button ref={csvRef} style={{ display: "none" }}>
            Download
          </button>
        </CSVDownloader>
      )}
    </div>
  );
}

export default CsvDownloader;
